<template>
  <div class="hero-section">
    <q-carousel
      swipeable
      animated
      v-model="currentSlide"
      autoplay
      infinite
      arrows
      height="180px"
      transition-prev="slide-right"
      transition-next="slide-left"
      class="rounded-borders carousel-container"
    >
      <q-carousel-slide 
        v-for="(banner, index) in banners" 
        :key="index" 
        :name="index" 
        @click="handleBannerClick(banner)"
      >
        <q-img 
          :src="banner.banner_image_url || '/images/offline-image-placeholder.png'" 
          class="full-height full-width carousel-image"
          fit="contain"
          position="center"
          no-spinner 
          @error="onImgError"
        />
        <!-- Removed title and description overlay -->
      </q-carousel-slide>
      
      <!-- Skeleton placeholder when loading -->
      <template v-if="loading">
        <q-carousel-slide name="loading">
          <q-skeleton height="180px" square />
        </q-carousel-slide>
      </template>
    </q-carousel>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'BannersMobile',
  props: {
    banners: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, null],
      default: null
    }
  },
  emits: ['banner-click', 'img-error'],
  setup(props, { emit }) {
    const currentSlide = ref(0);

    // Handle banner click
    const handleBannerClick = (banner) => {
      if (banner) {
        emit('banner-click', banner);
      }
    };

    // Handle image error
    const onImgError = (err) => {
      emit('img-error', err);
      if (err && err.target) {
        err.target.src = '/images/offline-image-placeholder.png';
      }
    };

    return {
      currentSlide,
      handleBannerClick,
      onImgError
    };
  }
});
</script>

<style scoped>
.hero-section {
  position: relative;
}

.carousel-container {
  max-width: 600px;
  margin: 0 auto;
}

.carousel-image {
  border-radius: 10px;
}
</style>
